import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const groupMedicalValidationSchema = () =>
  Yup.object({
    medicalDetails: Yup.object({
      covers: Yup.array()
        .of(
          Yup.object({
            coverID: requiredText(),
            isMandatory: Yup.boolean()
          })
        )
        .required('Required')
    }),
    documents: Yup.array()
      .of(
        Yup.object({
          documentId: requiredText(),
          documentName: requiredText(),
          documentPath: requiredText(),
          documentType: requiredText()
        })
      )
      .required('Required')
  });
